import * as Sentry from "@sentry/vue";

require('./bootstrap');
require('../components/realtime');
require('../components/state-calculator');

import 'alpinejs';
import Modal from './components/modal';
import FlashMessage from './components/flash-message';
import SlimSelect from 'slim-select';
import Clipboard from './components/clipboard';

class App {
	constructor() {
		// Promises waarop gewacht. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([App.domReady]).then(() => this.init());
	}

	init() {
		window.modal = new Modal();
		new FlashMessage();
		new Clipboard();
		if (document.querySelector('[data-select]')) {
			new SlimSelect({
				select: '[data-select]',
				search: false,
				showContent: 'down',
			});
		}
	}

	static domReady() {
		return new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new App();

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueApp from './vue/App.vue';
import TeamPlanet from '../student/vue/components/TeamPlanet.vue';

import Stations from './vue/Stations.vue';
import StationDetail from './vue/StationDetail.vue';

require('../components/store');
const appElement = document.querySelector('#app');

if (appElement) {
	Vue.use(VueRouter);

	const router = new VueRouter({
		routes: [
			{
				path: '/',
				component: Stations,
				name: 'stations',
			},
			{
				path: '/:uuid',
				component: StationDetail,
				name: 'station',
			},
		],
	});

	Sentry.init({
		Vue,
		dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
		integrations: [
			Sentry.browserTracingIntegration({ router }),
			Sentry.replayIntegration(),
		],
		tracesSampleRate: 1.0,
		tracePropagationTargets: ["localhost",  /^\//],
		replaysSessionSampleRate: 1.0,
		replaysOnErrorSampleRate: 1.0,
	});


	const app = new Vue({
		router,
		render: h =>
			h(VueApp, {
				props: {
					classUuid: appElement.attributes['data-class-uuid'].value,
					presentationScreenToken: appElement.attributes['data-presentation-screen-token'].value,
				},
			}),
	}).$mount(appElement);
}

const vuePlanets = document.querySelectorAll('[data-vue-planet]');

if (vuePlanets) {
	vuePlanets.forEach(vuePlanet => {
		const team = JSON.parse(vuePlanet.dataset.team);

		const planet = new Vue({
			render: h =>
				h(TeamPlanet, {
					props: {
						team: team,
					},
				}),
		}).$mount(vuePlanet);
	});
}
